<template>
  <div class="wrap">
    <div @mouseover="mouseOver"
         @mouseleave="mouseLeave">
      <swiper :options="swiperOption"
              class="swiper-banner"
              ref="swiperBanner">
        <swiper-slide>
          <div class="img-bg banner1"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner1.png"
               alt=""
               swiper-animate-effect="zoomIn"
               >
        </swiper-slide>
        <swiper-slide>
          <div class="img-bg banner2"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner2.png"
               alt=""
               swiper-animate-effect="zoomInRight"
               >
        </swiper-slide>
        <swiper-slide>
          <div class="img-bg banner3"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner3.png"
               alt=""
               swiper-animate-effect="zoomInDown"
               >
        </swiper-slide>
        <swiper-slide>
          <div class="img-bg banner3"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner4.png"
               alt=""
               swiper-animate-effect="zoomInDown"
               >
        </swiper-slide>
        <swiper-slide>
          <div class="img-bg banner3"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner5.png"
               alt=""
               swiper-animate-effect="zoomInDown"
               >
        </swiper-slide>
        <swiper-slide>
          <div class="img-bg banner3"
               swiper-animate-effect="fadeIn"
               ></div>
          <img class="img-txt ani"
               src="../../assets/images/airsep/banner6.png"
               alt=""
               swiper-animate-effect="zoomInDown"
               >
        </swiper-slide>
        <div class="swiper-pagination"
             slot="pagination"></div>
        <div class="swiper-button-prev swiper-button-white"
             slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-white"
             slot="button-next"></div>
      </swiper>
    </div>
    <div class="content bg">
      <div class="en t1"></div>
      <div class="inner product">
        <h2>关于我们</h2>
        <div class="details2">
          <div class="img">
            <div class="p1"></div>
            <div class="p2"><img src="../../assets/images/airsep/indeximg11.jpg" alt=""></div>
          </div>
          <div class="text">
            <p>埃珥赛璞医疗是集投资、研发、制造及运营为一体的高科技医疗装备和医疗器械企业，借势珠三角地区改革开放前沿和国际金融、贸易、制造和研发中心的领先地理位置，凭借国际最新的第三代医用中心制氧系统、医用气体系统、国内独家的小型医用中心制氧系统等一系列高技术医院项目，具有覆盖全国的投资和营销能力，能为全国代理商和医院提供完备的运营服务和技术支持。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="en t2"></div>
      <div class="inner product">
        <h2>产品展示</h2>
        <div class="details">
          <img src="../../assets/images/airsep/indeximg2.png" alt="">
          <img src="../../assets/images/airsep/indeximg3.png" alt="">
          <img src="../../assets/images/airsep/indeximg4.png" alt="">
        </div>
      </div>
    </div>
    <div class="content bg">
      <div class="en t3"></div>
      <div class="inner product newCenter">
        <h2>新闻中心</h2>
        <div class="details1">
          <div v-for="(item, index) in newList" :key="index" class="detailsContent">
            <p><strong><div class="dots" />{{ item.title }}</strong></p>
            <u @click="goNews(index)">{{ item.content }}</u>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { swiperAnimateCache, swiperAnimate } from '../../assets/js/swiper.animate.min.js'
import getAliyunImg from '../../utils/aliyun'

export default {
  name: 'Home',
  metaInfo: {
    title: '广州埃珥赛璞医疗设备有限公司', // set a title
    meta: [{ // set meta
      name: '医疗系统开发，医疗大数据应用，软件系统研发与集成，医疗装备研发生产与集成，数字病区',
      content: '广州埃珥赛璞医疗设备有限公司，是集医疗系统开发、医疗大数据应用、软件系统研发与集成、医疗装备研发生产与集成、投资、销售与运营服务为一体的高科技企业，项目坐落在中国光谷。'
    }],
    link: [{ // set link
      rel: '广州埃珥赛璞医疗设备有限公司',
      href: 'http://www.ytwdwh.com/'
    }]
  },
  created () {
    // this.imgUrl.banner1 = getAliyunImg.signatureUrl('ytwd/gw/index-banner11.png')
    // this.imgUrl.banner2 = getAliyunImg.signatureUrl('ytwd/gw/index-banner22.png')
    // this.imgUrl.banner3 = getAliyunImg.signatureUrl('ytwd/gw/index-banner33.png')
    // this.imgUrl.cdr = getAliyunImg.signatureUrl('ytwd/gw/cdr2.png')
    // this.imgUrl.iot = getAliyunImg.signatureUrl('ytwd/gw/iot.png')
    // this.imgUrl.equipment1 = getAliyunImg.signatureUrl('ytwd/gw/equipment1.jpg')
    // this.imgUrl.equipment2 = getAliyunImg.signatureUrl('ytwd/gw/equipment2.jpg')
    // this.imgUrl.equipment3 = getAliyunImg.signatureUrl('ytwd/gw/equipment3.jpg')
    // this.imgUrl.equipment4 = getAliyunImg.signatureUrl('ytwd/gw/equipment4.jpg')
    // this.imgUrl.equipment5 = getAliyunImg.signatureUrl('ytwd/gw/equipment5.jpg')
    this.imgUrl.banner1 = getAliyunImg.signatureUrl('')
    this.imgUrl.banner2 = getAliyunImg.signatureUrl('')
    this.imgUrl.banner3 = getAliyunImg.signatureUrl('')
    this.imgUrl.cdr = getAliyunImg.signatureUrl('')
    this.imgUrl.iot = getAliyunImg.signatureUrl('')
    this.imgUrl.equipment1 = getAliyunImg.signatureUrl('')
    this.imgUrl.equipment2 = getAliyunImg.signatureUrl('')
    this.imgUrl.equipment3 = getAliyunImg.signatureUrl('')
    this.imgUrl.equipment4 = getAliyunImg.signatureUrl('')
    this.imgUrl.equipment5 = getAliyunImg.signatureUrl('')
  },
  data () {
    return {
      imgUrl: {
        banner1: '',
        banner2: '',
        banner3: '',
        cdr: '',
        iot: '',
        equipment1: '',
        equipment2: '',
        equipment3: '',
        equipment4: '',
        equipment5: ''
      },
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许点击小圆点跳转
        },
        // on: {
        //   init: function () {
        //     // console.log(this)
        //     // console.log(swiperAnimateCache)
        //     swiperAnimateCache(this)
        //     swiperAnimate(this)
        //   },
        //   slideChangeTransitionStart: function () {
        //     swiperAnimate(this)
        //   },
        //   slideChangeTransitionEnd: function () {
        //     swiperAnimate(this)
        //   },
        //   slideChange: function () {
        //     swiperAnimate(this)
        //   }
        // },
        loop: true
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      },
      newList: [
        {
          id: '0',
          title: '（摘录）吉林氧气事故',
          url: 'https://news.youth.cn/gn/201707/t20170704_10224567.htm',
          content: '7月4日14时许，吉林省松原市宁江区繁华路巷路施工过程中造成燃气泄漏，燃气公司在抢修时发生爆炸，爆炸引发松...'
        },
        {
          id: '1',
          title: '2017年7月开始实行新《医疗器械标准管理办法》',
          url: 'https://www.gov.cn/gongbao/content/2017/content_5230281.htm',
          content: '《医疗器械标准管理办法》已于2017年2月21日经国家食品药品监督管理总局局务会议审议通过，现予公布，自2017年7月1日起施行...'
        },
        {
          id: '2',
          title: '卫计委要求：医疗机构一律停购大型医用设备',
          url: 'https://wjw.jiangsu.gov.cn/art/2024/1/12/art_81326_11123841.html',
          content: '据江苏省宿迁市卫计委网站6月30日消息，由于大型医用设备配置审批已经由非行政许可审批事项调整为行政许可事项，根据该省卫计委...'
        },
        {
          id: '3',
          title: '新规YY1468-2016《用于医用气体管道系统的氧气浓缩器供气系统》',
          url: 'http://www.gzh-winner.com/news/12.html',
          content: '为了更好地规范和推广使用富氧空气（93%氧），国家食品药品监督管理总局推出YY 1468-2016《用于医用气体管道系统的氧气浓缩器供气系统》...'
        },
        {
          id: '4',
          title: '十九大第五次记者会，民政部人社部卫计委回答要点记录（摘录）',
          url: 'http://www.moe.gov.cn/jyb_xwfb/gzdt_gzdt/moe_1485/201710/t20171023_317106.html',
          content: '10月23日，十九大新闻中心举行了第五场记者招待会。教育部党组书记、部长陈宝生，民政部党组书记、部长黄树贤，人力资源社会保障部党组书记...'
        },
        {
          id: '5',
          title: '医保、药价改革： 将致医药行业增速放缓、毛利降低',
          url: 'https://www.jiemian.com/article/1173070.html',
          content: '医保、药价改革：将致医药行业增速放缓、毛利降低.瑞银研究认为，医保、药价体系改革是2016-2017年的主旋律...'
        },
        {
          id: '6',
          title: '十九大报告为医改领域描绘了新的蓝图',
          url: 'https://baijiahao.baidu.com/s?id=1719700273682171172&wfr=spider&for=pc',
          content: '一、十九大报告做出的重大论断和新时期的目标任务指明了医改的前进方向.十九大报告开宗明义，提出了“为中国人民谋幸福...'
        },
        {
          id: '7',
          title: '广东分级诊疗模式初步形成',
          url: 'http://m.xinhuanet.com/health/2017-03/01/c_1120546627.htm',
          content: '广东分级诊疗模式初步形成2月28日，广东省卫计委召开全省医政工作会议，会上，省卫计委政务服务中心发布了全省医疗卫生事...'
        },
        {
          id: '8',
          title: '《“十三五”医疗器械科技创新专项规划》',
          url: 'https://www.most.gov.cn/xxgk/xinxifenlei/fdzdgknr/fgzc/gfxwj/gfxwj2017/201706/t20170614_133530.html',
          content: '先进医疗器械是健康保障体系建设的重要基础，是推进医学诊疗技术进步的主要动力，是优化医疗服务供给的核心引擎...'
        }
      ]
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    swiperBanner () {
      return this.$refs.swiperBanner.swiper
    }
  },
  updated () {
    // 确保 Swiper 实例已完全初始化
    if (this.swiperBanner) {
      console.log('this is current swiper instance object', this.swiperBanner)
      // 可以在这里执行与 Swiper 实例相关的操作
      // this.swiperBanner.slideTo(1, 1000, false);
    }
  },
  methods: {
    mouseOver () {
      this.swiperBanner.autoplay.stop()
    },
    mouseLeave () {
      this.swiperBanner.autoplay.start()
    },
    goNews (id) {
      // this.$store.commit('setActiveIndex', id)
      window.open(this.newList[id].url, '_blank')
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.newCenter{
  width: 1300px;
}
.bg {
  background: #fafafa;
}
.content {
  position: relative;
  padding: 80px 0 55px;
  .en {
    width: 100%;
    height: 69px;
    text-align: center;
    border-bottom: 1px solid #f3f3f3;
    position: absolute;
    top: 80px;
    left: 0;
    background-position: center top;
    background-repeat: no-repeat;
    &.t1 {
      background-image: url("../../assets/images/ABOUT-CDR.png");
    }
    &.t2 {
      background-image: url("../../assets/images/ABOUT-IOT.png");
    }
    &.t3 {
      background-image: url("../../assets/images/Medical-equipment.png");
    }
    &.t4 {
      background-image: url("../../assets/images/Cooperative-partner.png");
    }
  }
  .product {
    position: relative;
    z-index: 1;
    h2 {
      width: 338px;
      height: 68px;
      line-height: 68px;
      color: #6a6a6a;
      font-size: 24px;
      border-bottom: 2px solid #00dcd4;
      text-align: center;
      margin: 0 auto;
      em.color {
        color: #00dcd4;
      }
      em.line {
        color: #e9e9e9;
        padding: 0 10px;
        position: relative;
        top: -2px;
      }
    }
    .details {
      display: flex;
      justify-content: center;
      margin: 80px 0;
      img{
      width: 468px;
        margin-right: 30px;
        border: 1px solid #fff;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
      }
      .text {
        width: 575px;
        position: relative;
        &.bg {
          background: #fff url("../../assets/images/logo-bg.png") no-repeat
            center;
        }
        &.border {
          box-shadow: 1px 1px 35px 0px rgba(0, 0, 0, 0.14);
          border-radius: 40px;
          padding: 26px 30px;
        }
        &.border:before {
          content: "";
          position: absolute;
          display: block;
          top: 50%;
          margin-top: -14px;
          right: -31px;
          width: 0px;
          height: 0px;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          border-left: 31px solid #fff;
        }
        p {
          text-indent: 40px;
          font-size: 18px;
          line-height: 36px;
          color: #6a6a6a;
        }
      }
    }
    .details1{
      display: flex;
      justify-content: space-between;
      margin: 80px 0;
      flex-wrap: wrap;
      p{
        font-size: 20px;
        font-weight: 700;
        line-height: 36px;
        padding-bottom: 10px;
      }
      u{
        font-size: 18px;
        line-height: 30px;
        cursor: pointer;
        color: #666666;
      }
      .detailsContent{
        width: 47%;
        margin-bottom: 30px;
      }
      strong{
        display: flex;
        align-items: center;
        .dots{
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #3598FF;
          margin-right: 5px;
        }
      }
    }
    .details2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 80px 0;
      .img {
        width: 558px;
        min-height: 314px;
        position: relative;
        .p1 {
          width: 558px;
          height: 262px;
          margin-top: 26px;
          background: #d6f8f7;
        }
        .p2 {
          width: 468px;
          height: 314px;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 45px;
          img {
            width: 100%;
          }
        }
      }
      .text {
        width: 598px;
        position: relative;
        p {
          text-indent: 40px;
          font-size: 18px;
          line-height: 36px;
          color: #6a6a6a;
        }
        .site {
          width: 365px;
          margin-left: 35px;
          line-height: 28px;
          .dl {
            display: flex;
            margin-top: 18px;
            .dt {
              width: 75px;
              &::before {
                content: '';
                display: block;
                float: left;
                width: 22px;
                height: 22px;
                margin-top: 3px;
                margin-right: 5px;
                background-position: center;
                background-repeat: no-repeat;
              }
              &.address::before {
                background-image: url('../../assets/images/address2.png');
              }
              &.tel::before {
                background-image: url('../../assets/images/tel2.png');
              }
              &.email::before {
                background-image: url('../../assets/images/email2.png');
              }
            }
            .dd {
              flex: 1;
            }
          }
          .code {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 80px;
            left: 270px;
            span {
              display: block;
              text-align: center;
              margin-top: -12px;
            }
          }
        }
      }
    }
  }
}
</style>
